import { Typography } from '@material-ui/core'
import React from 'react'

const Title = ({ title, variant }) => {
    return (
        <Typography className="loanCalculatorTitle" variant={variant}>
            {title}
        </Typography>
    )
}

export default Title
